import { createContext, useContext } from "react";

type SearchContextType = {
  params?: any;
  onUpdateParams?: any;
  configs?: any;
  categoryLabel?: string;
  setCategoryLabel?: any;
};

const SearchContext = createContext<SearchContextType>({
  params: {},
  onUpdateParams: () => {},
  configs: {},
  categoryLabel: undefined,
  setCategoryLabel: () => {},
});

const useSearchContext = () => {
  return useContext(SearchContext);
};

export default SearchContext;

export { useSearchContext };
